var indexOf = [].indexOf;

angular.module('gym.bulkImports').controller('NewBulkImportCtrl', ["$scope", "$rootScope", "$stateParams", "$state", "$timeout", "loadingAnimation", "EmploymentService", "BulkImports", "flash", "meta", "policiesMeta", function($scope, $rootScope, $stateParams, $state, $timeout, loadingAnimation, EmploymentService, BulkImports, flash, meta, policiesMeta) {
  var clearForm, importTypes, isFileValid, ref, typesData;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.perform_bulk_imports) {
    $state.go('gym.dashboard');
  }
  $scope.gym = $rootScope.gym;
  $scope.meta = meta;
  $scope.policiesMeta = policiesMeta;
  $scope.fileData = {};
  importTypes = ['contact', 'membership_plan', 'product'];
  $scope.type = (ref = $stateParams.type, indexOf.call(importTypes, ref) >= 0) ? $stateParams.type : importTypes[0];
  typesData = {
    contact: {
      title: 'Contacts',
      sample: 'contact_sample.csv'
    },
    membership_plan: {
      title: 'Membership plans',
      sample: 'membership_plan_sample.csv'
    },
    product: {
      title: 'Products',
      sample: 'product_sample.csv'
    }
  };
  $scope.typeData = typesData[$scope.type];
  $scope.isReady = function() {
    var gdprReasonSelected, ref1;
    gdprReasonSelected = !$scope.gym.gdpr_applies || $scope.params.reason_for_data_collection;
    return ((ref1 = $scope.fileData.file) != null ? ref1.size : void 0) && !$scope.isLoading && gdprReasonSelected;
  };
  clearForm = function() {
    $scope.fileData.file = void 0;
    angular.element('#importInput').val('');
    return $scope.params = {
      import_type: $scope.type
    };
  };
  clearForm();
  $scope.cancel = function() {
    return $state.go('gym.bulkImports.list');
  };
  $scope.isRequired = function(column) {
    return indexOf.call(meta.required_columns[$scope.type], column) >= 0;
  };
  isFileValid = function(file) {
    var names;
    names = file.name.split('.');
    return names.length > 1 && names.pop() === 'csv';
  };
  $scope.$watch('fileData.file', function(file) {
    var reader;
    if (file != null ? file.size : void 0) {
      reader = new window.FileReader();
      reader.readAsText(file);
      return reader.onloadend = function() {
        return $timeout(function() {
          if (!isFileValid(file)) {
            clearForm();
            return flash.error = "Upload must be in CSV format";
          } else {
            $scope.params.file_name = file.name;
            return $scope.params.file_content = reader.result;
          }
        });
      };
    }
  });
  return $scope.upload = function() {
    if (!$scope.isReady()) {
      return;
    }
    $scope.isLoading = true;
    return BulkImports.all('bulk_imports').post($scope.params).then(function(data) {
      flash.success = "Upload queued for processing";
      $state.go('gym.bulkImports.show', {
        id: data.id
      });
      return clearForm();
    }, function(response) {
      var ref1, ref2;
      clearForm();
      $scope.isLoading = false;
      return flash.error = ((ref1 = response.data.errors) != null ? (ref2 = ref1.status) != null ? ref2[0] : void 0 : void 0) || "Request could not be completed. Please try again";
    });
  };
}]);
